import { css } from '@emotion/css';
import { Theme } from '@mui/material';

import { useStyles } from '@/hooks/useStyles';
import { usePatientMonitoringContext } from '@/pages/patient-monitoring/PatientMonitoringState';
import { Queries } from '@/queries/Queries';

import { DoctorRenewNudge } from './DoctorRenewNudge';
import { NurseNoticeBanner } from './NurseNoticeBanner';
import { NurseReinclusionNudge } from './NurseReinclusionNudge';
import { NurseReinclusionRequestBanner } from './NurseReinclusionRequestBanner';

export const PatientDetailNudges = () => {
  const state = usePatientMonitoringContext(s => s);
  const me = Queries.user.usePractitionerMe({});
  const { data: featureFlags } = Queries.user.useFeatureFlags({});
  const styles = useStyles(makeStyles);

  const nurseReinclusionActive = !!featureFlags?.['nurse-reinclusion-request'];
  const renewNudgeActive = !!featureFlags?.['renewal-nudge'];

  if (me.qualification === 'doctor') {
    return (
      <div className={styles.wrapper}>
        <NurseNoticeBanner patientId={state.patient.id} />
        {nurseReinclusionActive && (
          <NurseReinclusionRequestBanner patientId={state.patient.id} />
        )}
        {renewNudgeActive && <DoctorRenewNudge patientId={state.patient.id} />}
      </div>
    );
  }

  if (me.qualification === 'nurse') {
    return (
      <div className={styles.wrapper}>
        {nurseReinclusionActive && (
          <NurseReinclusionNudge patientId={state.patient.id} />
        )}
      </div>
    );
  }

  return null;
};

const makeStyles = (theme: Theme) => ({
  container: css`
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding: ${theme.spacing(8, 12)};
  `,
  wrapper: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(8)};
    padding-bottom: ${theme.spacing(8)};
  `,
  ctas: css`
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing(4)};
  `,
  col: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(4)};
  `,
});
